import React from "react";
import { Answer } from "../../components/answers/badge/answer";
import { SelectChoice } from "../../components/drop_down/SelectChoice";
import { CorrectAnswer } from "../../components/answers/correct_answer";
import { WrongAnswer } from "../../components/answers/wrong_answer";
import { type } from "./QuizRunner";
import { useCallback, useEffect } from "react";
// import { TempUrl } from "../../libs/env";
export const InputMultiSelectTypeQuestion = ({
  isReview,
  answer,
  question,
  node,
  onAnswer,
  exercise_id,
  page_id,
  section_id,
  data,
  isFielddisabled
}) => {
  let user_answer;
  // let params = new URL(document.location).searchParams;
  // let edit_template = params.get("edit_template");
  let fieldsize = "form-select-custom-sm";
  // if( edit_template === "true" || window.location.pathname.includes(TempUrl))
  // {
  //   fieldsize = "preview-select-custom-sm"
  // }
  if (data.type === type.Assessment) {
    
    answer.forEach((answ) => {
      if (
        answ.section_id === section_id &&
        answ.exercise_id === exercise_id &&
        answ.page_id === page_id
      ) {
        answ.answers.forEach((ans) => {
          if (ans.question_id === question.id) {
            ans.selected_answers.forEach((sel_ans) => {
              if (parseInt(node.attribs["data-id"]) === sel_ans["number"]) {
                user_answer = sel_ans["id"];
              }
            });
          }
        });
      }
    });
  } else {
    answer.forEach((ans) => {
      if (ans.question_id === question.id) {
        ans.selected_answers.forEach((sel_ans) => {
          if (parseInt(node.attribs["data-id"]) === sel_ans["number"]) {
            user_answer = sel_ans["id"];
          }
        });
      }
    });
  }

  let question_answer_number = [];
  let dropdown_corrent_answer;

  let question_flag;
  if (isReview) {
    question.possible_answers.forEach((possible_answer) => {
      if (
        possible_answer.number === parseInt(node.attribs["data-id"]) &&
        possible_answer.is_correct
      ) {
        dropdown_corrent_answer = possible_answer.prompt_content.replaceAll(
          /(<([^>]+)>)/gi,
          ""
        );
      }
    });
  }
  if (isReview && question.user_selected) {
    question.user_selected.forEach((user_selected) => {
      if (parseInt(node.attribs["data-id"]) === user_selected.number) {
        (question.possible_answers).forEach((possible_answer) => {
          if (
            possible_answer.number === user_selected.number &&
            possible_answer.id === user_selected.id
          ) {
            question_answer_number.push(possible_answer);

            question_flag = possible_answer.is_correct;
          }
        });
      }
    });
  } else if (isReview === false) {
    question.possible_answers.forEach((question_number) => {
      if (parseInt(node.attribs["data-id"]) === question_number.number) {
        question_answer_number.push(question_number);
      }
    });
  }
  const updatelinebreaking = useCallback(() => {
    const elements = document.querySelectorAll(".editquestions b");
    var currentElement = document.querySelectorAll(
      `.select${question.id}${parseInt(node.attribs["data-id"])}`
    );
    currentElement.forEach((mainelement) => {
      elements.forEach((bElement) => {
        if (
          bElement.textContent.trim() ===
            `${parseInt(node.attribs["data-id"])})` || bElement.textContent.trim() ===
            `${parseInt(node.attribs["data-id"])}`
        ) {
          const firstChild = mainelement.firstChild;
          if (bElement.textContent.trim() !== firstChild.textContent.trim()) {
            const spanElement = bElement.nextElementSibling;
            if (spanElement && spanElement.textContent === ")"){
              mainelement.insertBefore(spanElement, mainelement.firstChild);
            }
            mainelement.insertBefore(bElement, mainelement.firstChild);
          }
        } else {
          var parentElement = mainelement.parentNode ;
          if(parentElement.tagName.toLowerCase() !== "td")
          {
            parentElement.classList.add("d-inline-block");
          }
        }
      });
    });

  }, [question, node]);
  
  useEffect(() => {
    updatelinebreaking();
  }, [updatelinebreaking]);

  return (
    <div class={`inline-block icon-wrapper contentremove select${question.id}${parseInt(node.attribs["data-id"])}`}>
      <span contentEditable={false}>
      <span  className="data_id d-none">{`[[${node.attribs["data-id"]}]]`}</span>
      <SelectChoice
        id={user_answer}
        disabled={isFielddisabled ? true: isReview}
        data-question-type={question.type}
        data-value={node.attribs["data-id"]}
        data-question-id={question.id}
        data-exercise-id={exercise_id}
        data-section-id={section_id}
        data-page-id={page_id}
        placeholder_id={node.attribs["data-id"]}
        choices={question_answer_number}
        onblur={onAnswer}
        isReview={isReview}
        className={
          question_flag === false
            ? "txt-danger-line-through form-select form-select-custom-sm no-download"
            : `form-select ${fieldsize} no-download`
        }
      />
      
      {isReview ? (
        question_flag === true ? (
          <CorrectAnswer class="answer-badge bg-success" />
        ) : (
          <WrongAnswer class="answer-badge bg-danger" />
        )
      ) : null}
      {isReview ? (
        question_flag === true ? null : (
          <Answer
            class="badge bg-success mb-1"
            value={dropdown_corrent_answer}
          />
        )
      ) : null}
      </span>
    </div>
  );
};
